import { render } from "./AdminCustomEntry.vue?vue&type=template&id=20539465"
import script from "./AdminCustomEntry.vue?vue&type=script&lang=js"
export * from "./AdminCustomEntry.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-simple-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__